import { MuiButton } from '@/components/button/MuiButton';
import { api_portalOfficeListing_filter } from '@/init/swagger';
import { SearchAppHomeType } from '@/schemas/SearchAppHomeSchema';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  List,
  ListItem,
} from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

const DEFAULT_SHOW_LENGTH = 7;

type Props = {
  filters: api_portalOfficeListing_filter[];
  toggleCheckboxForMedicalSubject: ({
    medicalSubjectId,
  }: {
    medicalSubjectId: number;
  }) => void;
};

export function SearchFilterListForMedicalSubject({
  filters,
  toggleCheckboxForMedicalSubject,
}: Props) {
  const { watch } = useFormContext<SearchAppHomeType>();

  const [loadIndex, setLoadIndex] = useState(DEFAULT_SHOW_LENGTH);

  const moreShow = () => {
    if (loadIndex === DEFAULT_SHOW_LENGTH) {
      setLoadIndex(filters.length);
    } else {
      setLoadIndex(DEFAULT_SHOW_LENGTH);
    }
  };

  return (
    <>
      <List disablePadding sx={{ width: '100%' }}>
        {filters.slice(0, loadIndex).map((searchFilter) => {
          return (
            <ListItem
              key={`${searchFilter.category_id}_${searchFilter.id}`}
              disablePadding
              sx={{
                mb: -1,
                '& .MuiFormGroup-root': {
                  backgroundColor: 'unset',
                },
              }}
            >
              <FormGroup
                sx={{
                  backgroundColor: 'bg.lighter',
                  alignItems: 'center',
                  pl: 0,
                }}
              >
                <FormControlLabel
                  label={searchFilter.label}
                  style={{
                    marginLeft: '0rem',
                    marginRight: 2,
                  }}
                  control={
                    <Checkbox
                      checked={watch(`medical_subjects`).includes(
                        searchFilter.id!,
                      )}
                      onChange={() => {
                        toggleCheckboxForMedicalSubject({
                          medicalSubjectId: searchFilter.id!,
                        });
                      }}
                      sx={{
                        pl: 0,
                      }}
                    />
                  }
                />
              </FormGroup>
            </ListItem>
          );
        })}
      </List>

      <MuiButton
        variant="text"
        onClick={moreShow}
        size="small"
        sx={{ width: 'max-content' }}
      >
        {loadIndex === DEFAULT_SHOW_LENGTH ? 'もっと見る' : '閉じる'}
      </MuiButton>
    </>
  );
}
